import React from 'react';
import { ISnacksProps } from './interfaces/ISnacksProps';

interface SnackbarContextInterface {
  openSnacks: ISnacksProps[];
  setSnacks: (snacks: ISnacksProps[]) => void;
  openSnack: (snack: ISnacksProps) => void;
}
export const SnackbarContext = React.createContext<SnackbarContextInterface>({
  openSnacks: [],
  setSnacks: (_snacks: ISnacksProps[]) => {
    // intentionally left blank
  },
  openSnack: (_snack: ISnacksProps) => {
    // intentionally left blank
  },
});
